import {ModelInterface} from "../../data-structures/collection";
import {
    NavigationButtonPosition,
    NavigationSectionConfig,
    NavigationSectionType,
    ScrollToInMenu
} from "../navigation/@const";
import NavigationSection from "../navigation/navigation-section";
import {BUS_SHOW_IN_MENU} from "../../../layout/menu/@events";
import ProjectSession from "../project/project-session";
import StarredItem from "../starred/starred-item";
import space_setSorting from "./actions/set-sorting";
import {ProjectsTreeSortType} from "./@types";
import space_getSorting from "./actions/get-sorting";
import space_getProjectsColorize from "./actions/get-colorize";
import space_setColorize from "./actions/set-colorize";
import Workspace from "./workspaces/workspace";
import {
    OptionNavigationPanelBottom,
    OptionNavigationPanelMore,
    OptionNavigationPanelTop
} from "../../../layout/navigation/@const";
import {getNavigationPosition} from "../navigation/functions/get-navigation-position";
import navigation_setPositionNew from "../../../layout/navigation/actions/set-navigation-position-new";
import {PopoverMenuItemType} from "../../gd-components/popover-menu/popover-menu/const";

// const debug = "SpaceProto"
const debug = false

export class SpaceProto implements ModelInterface {

    public id                   : ID | NavigationSectionType // ID - custom spaces NavigationSectionType - system spaces
    public navigation!          : NavigationSection
    public title                : string    = "Space"
    public canHaveProjects      : boolean   = false     // if true this space can have projects
    public icon                 : string    = 'i5-structure-1'
    public svgIcon?             : string    = undefined     // optional - only system spaces have it ?

    public positions            : NavigationButtonPosition[]    // positions availabel for this button
    public defaultPosition      : NavigationButtonPosition      // default position for this space

    constructor(id : ID | NavigationSectionType) {
        this.id                 = id

        this.defaultPosition    = NavigationButtonPosition.TOP // default position for this space
        this.positions          = [NavigationButtonPosition.TOP, NavigationButtonPosition.MORE]
    }

    // return null when no label needed
    get navigationPanelLabel():string|null {
        return this.title
    }

    // default click on the space
    onClick() {
        throw Error("#09484 not implemented")
    }

    // Ne vsegda nujen GroupedData. Na primer chats. Type ukazivaem v dochernix classax
    search(keyword:string): any {
        throw Error("0328387r444 Not implemented")
    }

    get hasSearch(): boolean {
        return true
    }

    get position() : NavigationButtonPosition {

        let position : NavigationButtonPosition = _.get(gd.user.settings.navigation.buttonPositions, this.id, this.defaultPosition)

        // defualt / fallback
        if (!this.positions.includes(position)) {
            // console.log(this.id, "patch position")
            position = this.defaultPosition
        }

        return position
    }

    set position (position : NavigationButtonPosition) {

        debug && console.log(debug, "set position", position)

        if (this.position === NavigationButtonPosition.STATIC) {
            debug && console.log(debug, "    this space is static - no set position allowed")
            return
        }

        // ... need better way but ok for now
        navigation_setPositionNew(this.navigation, position)
    }

    // return display in options
    getDisplayOptions():Options {

        if (_.size(this.positions) < 2 ) {
            return []
        }

        const options : Options = []

        _.map(this.positions, (position) => {
            switch (position) {
                case NavigationButtonPosition.TOP:
                    options.push(OptionNavigationPanelTop)
                    break
                case NavigationButtonPosition.BOTTOM:
                    options.push(OptionNavigationPanelBottom)
                    break
                case NavigationButtonPosition.MORE:
                    options.push(OptionNavigationPanelMore)
                    break
                case NavigationButtonPosition.STATIC:
                    // do nothing
                    break
                // default:
                //     break
            }

        })

        return options

    }

    get projectsColorize():boolean {
        // return gd.user.settings.navigation.spacesPreferences[this.id]?.projectsColorize || false
        return space_getProjectsColorize(this)
    }

    set projectsColorize(projectsColorize: boolean) {
        space_setColorize(this, projectsColorize)
    }

    set projectsSorting(projectsSorting: ProjectsTreeSortType) {
        space_setSorting(this, projectsSorting)
    }

    get projectsSorting():ProjectsTreeSortType {
        return space_getSorting(this)
    }

    get sortMapId() {
        return this.id === 'projects' ? 'root' : this.id
    }

    get isResetManualSortingAvailable() {
        return !_.isNil(gd.user.menu.projectsAll.sortedMap[this.sortMapId])
    }

    // reset manual sorting
    resetSortedMap() {
        delete gd.user.menu.projectsAll.sortedMap[this.sortMapId]
        gd.user.menu.save()

        // delete gd.user.settings.navigation.spacesPreferences[this.id]?.sortedMap
        // gd.user.settings.save()
    }

    async openMenu(scrollTo?:ScrollToInMenu) {

        await gd.layout.navigation.openSectionV2(this.navigation)

        scrollTo && gd.bus.triggerEvent(BUS_SHOW_IN_MENU, scrollTo)

        return true
    }

    get isWorkspace(): boolean {
        return false
    }

    get isSection(): boolean {
        return false
    }

    get enabled(): boolean {
        return true
    }

    get inNavigationPanel():boolean {

        if (!this.navigation) {

            // HAPPENS WHEN CHATS NOT THERE
            if (this.id === 'chats') {
                return false
            }

            // projects - happens when no space projects
            if (this.id === 'projects') {
                return false
            }


            // happens when no chat enabled or space is in more
            // console.error("#kkdjdjd-3 how come no navigation ?")
            // console.log("No navigation for space ", this.id)

            return false
        }

        return this.enabled && (this.position === NavigationButtonPosition.TOP || this.position === NavigationButtonPosition.BOTTOM)
    }

    get inNavigationMore():boolean {
        return this.navigation?.position === NavigationButtonPosition.MORE
    }

    get navigationStructureConfig():NavigationSectionConfig {
        throw Error("#ld9238djs not implemented")
    }

    get rootProjects():ProjectSession[] {
        throw Error("#ksnm230 not implemented")
    }

    get starredProjects():ProjectSession[] {

        const projects  : ProjectSession[] = []

        // gd.session.starredItems.getProjectStarredItem()
        _.map(gd.session.starredItems.models, (starredItem:StarredItem)=>{
            if (starredItem.space?.id === this.id) {
                const project : ProjectSession | null = gd.session.projects.get(starredItem.projectId)

                // Only valid if the project is not a workspace project
                if (project && !project.isWorkspace) {
                    projects.push(project)
                }
            }
        })

        return projects
    }


    initNavigation() {

        if (!this.enabled) return

        this.navigation         = new NavigationSection(this.navigationStructureConfig)
        this.navigation.space   = this
        gd.navigationStructure.add(this.navigation)
    }

    removeNavigation() {
        if (this.navigation) {
            gd.navigationStructure.remove(this.navigation.id)
        }
    }

    get contextMenuOptions():Options {

        debug && console.log(debug, 'contextMenuOptions()')

        let moreOptions : Option[] = []

        if (this.isWorkspace) {
            moreOptions.push({
                label       : "Info",
                icon        : 'ii5-information',
                onClick     : () => {
                    const workspace :Workspace = this as unknown as Workspace
                    workspace.project.goToInfo()
                }
            })
        }

        const displayOptions : Option[] = this.getDisplayOptions()

        if (!_.isEmpty(displayOptions)) {

            moreOptions.push({
                type        : PopoverMenuItemType.HEADER,
                label       : 'Display In:'
            })

            const position = this.position

            // add display options
            _.map(displayOptions, (option:Option) => {
                option              = _.clone(option)    // because we modify it below
                option.isSelected   = option.value === position
                // option.onClick      = () => setDisplayPosition(option.value as NavigationButtonPosition)
                option.onClick      = () => {
                    this.position = option.value as NavigationButtonPosition
                }
                moreOptions.push(option)
            })

        }

        return moreOptions

    }

    // WHERE do we use it ?
    // WHY function ????
    // DEPRICATED !!!
    getViewMoreOptions():func {

        const navigationSectionType = this.id as NavigationSectionType

        return () => {
            const position = getNavigationPosition(navigationSectionType)

            // debug && console.log(debug, 'render', navigationSectionType, position)

            const setDisplayPosition = async (position:NavigationButtonPosition) => {
                // navigation_setPositionDeprecated(navigationSectionType, position)
                navigation_setPositionNew(this.navigation, position)
            }

            const moreOptions : Option[] = [{
                type        : PopoverMenuItemType.HEADER,
                label       : 'Display In:'
            }]

            const positionOptions = this.positions

            // add display options
            _.map(positionOptions, (option:Option) => {
                option              = _.clone(option)    // because we modify it below

                option.isSelected   = option.value === position
                option.onClick      = () => setDisplayPosition(option.value as NavigationButtonPosition)
                moreOptions.push(option)
            })

            return moreOptions
        }
    }



    toJSON() {
        throw Error("#90d82kkk not implemented")
    }

    toOption():Option {

        let icon = this.icon
        if (this.isWorkspace) {
            const workspace = this as unknown as Workspace
            icon = "{0} gd-c-font-{1}".f(workspace.icon, workspace.project.color)
        }

        return {
            value   : this.id,
            icon    : icon,
            label   : this.title,
        }
    }


}
